import { TlfItemTable } from "../common/tlfItemTable/TlfItemTable";
import "./HierarchyBrowser.css";
import { useHBC } from "./HierarchyBrowserContextProvider";
import { HierarchyBrowserLhs } from "./HierarchyBrowserLhs";
import { SET_SELECTIONS } from "./interface";

export interface HierarchyBrowserProps {
  heightPx?: number;
  selectReportVariants?: boolean;
  width?: string;
}

/**
 * Main hierarchy browser component.
 *
 * @param props - Component props
 * @param props.heightPx - Height in pixels for the browser area
 * @param props.selectReportVariants - Offers separate Master/variant outputs in report-copy dialogs
 * @param props.width - Width of the browser area (CSS string)
 */
export const HierarchyBrowser = ({
  heightPx = 400,
  selectReportVariants = false,
  width = "100%",
}: HierarchyBrowserProps) => {
  const { state, dispatch } = useHBC();
  return !state ? null : (
    <div
      className="hierarchy-browser"
      id={`${state?.id}`}
      style={{
        position: "relative",
        minHeight: `${heightPx}px`,
        height: `${heightPx}px`,
        maxHeight: `${heightPx}px`,
        minWidth: width,
        width: width,
        maxWidth: width,
      }}
    >
      <HierarchyBrowserLhs />
      <div
        className="hb-right"
        id={`${state.id}-right`}
        style={{ overflow: "hidden" }}
      >
        <div className="hb-container">
          <TlfItemTable
            id={`tlfitemtable-${state.currentHierarchyType}`}
            selectedItems={state.canSelect ? state.selections?.map((s) => s.id) : undefined}
            selectReportVariants={selectReportVariants}
            setSelectedItems={
              state.canSelect
                ? (ret) => {
                    const thisHierarchyIndex = state.hierarchyTlfItemIndex.find(
                      (ix) => ix.hierarchyId === state.currentHierarchy,
                    )?.tlfItemIndex;
                    /* istanbul ignore else */
                    if (thisHierarchyIndex) {
                      dispatch({
                        operation: SET_SELECTIONS,
                        selections: ret
                          .map((id) => thisHierarchyIndex.find((tlf) => tlf.id === id))
                          .filter((tlf) => tlf !== undefined)
                          .map((tlf) => ({
                            id: tlf!.id,
                            azsolId: tlf!.azsolId,
                            domain: tlf!.domain,
                          })),
                      });
                    }
                  }
                : undefined
            }
          />
        </div>
      </div>
    </div>
  );
};

HierarchyBrowser.displayName = "HierarchyBrowser";
